import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Time } from '@angular/common';
import { LeverancierStatus } from './regels.service';

@Injectable({
  providedIn: 'root'
})
export class RegelDetailsService {
  _baseUrl: string;

  constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._baseUrl = baseUrl;
  }

  get(id: string): Observable<IRegelDetails> {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregel/getdetailsresult';

    let param: any;
    param = { 'id': id };

    return this._httpClient.get<IRegelDetails>(requestUrl, { params: param });
  }

  getSupply(supplierAssignedId: string, kwekerEan?: number): Observable<ISupply> {
    const requestUrl = this._baseUrl + 'api/supply/GetSupply';

    let param: any;
    param = { 'supplierAssignedId': supplierAssignedId };
    if (kwekerEan) param.kwekerEan = kwekerEan;

    return this._httpClient.get<ISupply>(requestUrl, { params: param });
  }

  updateMeta(item: IRegelLeverancierDetails): Observable<any> {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregelleverancier/' + item.id || '';
    if (item.id)
      return this._httpClient.put(requestUrl, item);
    else {
      item.id = (<any>crypto).randomUUID();
      const requestUrl = this._baseUrl + 'api/offerteaanvraagregelleverancier/add';
      return this._httpClient.post(requestUrl, item);
    }

  }
}

export class RegelDetails implements IRegelDetails {
  constructor() {
    this.leverancierDetails = new LeverancierDetails();
  }
  aantallenInAanvraagType: string;

  id: string;
  handelType: string;
  verladingType: string;
  ladingdragerType1: string;
  ladingdragerType2: string;
  ladingdragerType3: string;
  offerteAanvraagOmschrijving: string;
  sourceId: number;
  deadlineInkoopDate?: Date;
  deadlineLeverancierDate?: Date;
  debiteurNaam: string;
  afleverperiodeVanJaar?: number;
  afleverperiodeVanWeek?: number;
  afleverperiodeTotJaar?: number;
  afleverperiodeTotWeek?: number;
  aeadlineInkoopDate?: Date;
  aeadlineLeverancierDate?: Date;
  geldigheidKwekersaanbiedingTot?: Date;
  aantal?: number;
  potmaat?: number;
  maxHoogteLadingdrager1?: number;
  maxHoogteLadingdrager2?: number;
  maxHoogteLadingdrager3?: number;
  busdienstCheck: boolean;
  hoogte?: number;
  opmerking: string;
  kleur: string;
  stadium: string;
  werkelijkeInkoopprijs?: number;
  dooshoogte?: number;
  aantalLagenPerLadingdrager1?: number;
  stuks1?: number;
  fustenPerLaag1?: number;
  kwekerEan: number;
  kwekerGTIN: number;
  inkoperNr?: number;
  hamiplantArtikelNr?: number;
  omschrijving: string;
  version: number;
  locatieProductlabelCode1: string;
  aantalBloemen: string;
  aantalTakken: string;
  opmerkingInkoop: string;
  handelTypeId?: number;
  verladingTypeId?: number;
  isSticker?: boolean;
  aantalLagenPerLadingdrager2?: number;
  aantalLagenPerLadingdrager3?: number;
  stuks2?: number;
  stuks3?: number;
  stickerprijs1?: number;
  stickerprijs2?: number;
  stickerprijs3?: number;
  locatieProductlabelCode2: string;
  locatieProductlabelCode3: string;
  fustenPerLaag2?: number;
  fustenPerLaag3?: number;
  opmerkingLeverancier: string;
  supplierAssignedId: string;
  fustNr1?: number;
  fustNr2?: number;
  fustNr3?: number;
  isInclusiefSticker: boolean;
  photos: string[];
  createdDate: Date;
  modifiedDate?: Date;

  leverancierDetails?: IRegelLeverancierDetails;
}

export class LeverancierDetails implements IRegelLeverancierDetails {
  werkelijkeInkoopprijs?: number;
  dooshoogte?: number;
  locatieProductlabelCode1: string;
  locatieProductlabelCode2: string;
  locatieProductlabelCode3: string;
  stickerprijs1?: number;
  stickerprijs2?: number;
  stickerprijs3?: number;
  fustNr1?: number;
  aantalLagenPerLadingdrager1?: number;
  stuks1?: number;
  fustenPerLaag1?: number;
  ladingdragerType1: string;
  maxHoogteLadingdrager1?: number;
  aantalLagenPerLadingdrager2?: number;
  fustNr2?: number;
  maxHoogteLadingdrager2?: number;
  fustenPerLaag2?: number;
  stuks2?: number;
  ladingdragerType2: string;
  aantalLagenPerLadingdrager3?: number;
  stuks3?: number;
  fustNr3?: number;
  fustenPerLaag3?: number;
  ladingdragerType3: string;
  maxHoogteLadingdrager3?: number;
  public get isDisabled(): boolean { return this.confirmationDate != null }
  confirmationDate?: Date;
  geldigheidKwekersaanbiedingTot?: Date;
  hoogte?: number;
  offerteAanvraagRegelId: string;
  opmerkingLeverancier: string;
  opmerkingInkoop: string;
  stadium: string;
  aantalBloemen: string;
  aantalTakken: string;
  isInclusiefSticker: boolean;
  kleur: string;
  id: string;
}

export interface IRegelDetails {
  offerteAanvraagId?: number;
  id?: string;
  sourceId?: number;
  offerteAanvraagOmschrijving: string;
  debiteurNaam: string;
  afleverperiodeVanJaar?: number;
  afleverperiodeVanWeek?: number;
  afleverperiodeTotJaar?: number;
  afleverperiodeTotWeek?: number;
  deadlineInkoopDate?: Date;
  deadlineLeverancierDate?: Date;
  geldigheidKwekersaanbiedingTot?: Date;
  aantal?: number;
  potmaat?: number;
  hoogte?: number;
  opmerking?: string;
  kleur?: string;
  stadium?: string;
  werkelijkeInkoopprijs?: number;
  dooshoogte?: number;
  aanlevertijdDagenEerder?: number;
  aanlevertijd?: Time;
  kwekerEan?: number;
  kwekerGTIN?: number;
  inkoperNr?: number;
  hamiplantArtikelNr?: number;
  omschrijving?: string;
  version?: number;
  aantalBloemen?: string;
  aantalTakken?: string;
  opmerkingInkoop?: string;
  handelTypeId?: number;
  handelType?: string;
  verladingTypeId?: number;
  verladingType?: string;
  isSticker?: boolean;
  locatieProductlabelCode1?: string;
  locatieProductlabelCode2?: string;
  locatieProductlabelCode3?: string;
  stickerprijs1?: number;
  stickerprijs2?: number;
  stickerprijs3?: number;
  opmerkingLeverancier?: string;
  supplierAssignedId?: string;
  fustNr1?: number;
  aantalLagenPerLadingdrager1?: number;
  stuks1?: number;
  fustenPerLaag1?: number;
  ladingdragerType1?: string;
  maxHoogteLadingdrager1?: number;
  aantalLagenPerLadingdrager2?: number;
  fustNr2?: number;
  maxHoogteLadingdrager2?: number;
  fustenPerLaag2?: number;
  stuks2?: number;
  ladingdragerType2?: string;
  aantalLagenPerLadingdrager3?: number;
  stuks3?: number;
  fustNr3?: number;
  fustenPerLaag3?: number;
  ladingdragerType3?: string;
  maxHoogteLadingdrager3?: number;
  isInclusiefSticker?: boolean;
  busdienstCheck?: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  photos: string[];
  aantallenInAanvraagType?: string;
  leverancierDetails?: IRegelLeverancierDetails;
}

export interface IRegelLeverancierSimple {
  offerteAanvraagRegelId?: string;
  supplierAssignedId?: string;
  omschrijving?: string;
  status?: LeverancierStatus;
  hoogte?: number;
}

export interface IRegelLeverancierDetails extends IRegelLeverancierSimple  {
  potmaat?: number;
  geldigheidKwekersaanbiedingTot?: Date;
  opmerkingLeverancier?: string;
  opmerkingInkoop?: string;
  stadium?: string;
  werkelijkeInkoopprijs?: number;
  dooshoogte?: number;
  aantalBloemen?: string;
  aantalTakken?: string;
  isInclusiefSticker?: boolean;
  locatieProductlabelCode1?: string;
  locatieProductlabelCode2?: string;
  locatieProductlabelCode3?: string;
  stickerprijs1?: number;
  stickerprijs2?: number;
  stickerprijs3?: number;
  fustNr1?: number;
  aantalLagenPerLadingdrager1?: number;
  stuks1?: number;
  fustenPerLaag1?: number;
  ladingdragerType1?: string;
  maxHoogteLadingdrager1?: number;
  aantalLagenPerLadingdrager2?: number;
  fustNr2?: number;
  maxHoogteLadingdrager2?: number;
  fustenPerLaag2?: number;
  stuks2?: number;
  ladingdragerType2?: string;
  aantalLagenPerLadingdrager3?: number;
  stuks3?: number;
  fustNr3?: number;
  fustenPerLaag3?: number;
  ladingdragerType3?: string;
  maxHoogteLadingdrager3?: number;
  kleur?: string;
  id?: string;
  isDisabled?: boolean;
  confirmationDate?: Date;
  offerteAanvraagId?: number;

  //only needed to create a new Regel
  parentId?: string;
  alternatieveOfferteAanvraagRegelId?: number;
  kwekerEan?: number;
}

export interface ISupply{
    images: string[];
    karvolume: number;
    boxType: number;
    numberOfUnitsPerBox: number;
    numberOfBoxesPerLayer: number;
    numberOfBoxesPerCarrier: number;
    numberOfLayersPerCarrier: number;
    hoogte: number;
    potmaat: number;
    id: string;
    documentType: number;
    supplierGLN: number;
    marketplaceGLN: number | null;
    industryAssignedId: number;
    supplierAssignedId: string;
    supplierGTIN: number | null;
    createdDate: Date | string;
    createdBy: string;
    modifiedDate: Date | string | null;
    modifiedBy: string;
    entryDate: Date | string;
    mutatedDate: Date | string;
    expiryDate: Date | string | null;
    tradeItemId: string | null;
    description: string;
    bluerootsSequenceNumber: number;
    dimensionHeight: number | null;
    dimensionDiameter: number | null;
    isModifiedWithFdData: boolean;
    conflictText: string;
    conflictScanDate: Date | string | null;
}
